var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item,index){return _c('Tag',{key:index,ref:"tags",refInFor:true,attrs:{"data":item,"isSelectable":_vm.isSelectable,"isLinks":_vm.isLinks},on:{"change":_vm.onTagChange}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }